import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PersonRedirect } from '../shared/enums/redirectDecision';

@Injectable({
   providedIn: 'root'
})
export class HomeService {
   constructor(private httpClient: HttpClient) {}

   getStudentStatus(
      taxNumber: string,
      uuid?: string,
      birthDate?: string,
      language?: 'HU' | 'EN'
   ): Observable<{ status: PersonRedirect; uuid: string }> {
      const params: { [param: string]: string | number | boolean } = {};
      if (uuid !== undefined) {
         params['uuid'] = uuid;
      }
      if (birthDate !== undefined) {
         params['birthDate'] = birthDate;
      }
      if (language !== undefined) {
         params['language'] = language;
      }
      return this.httpClient.get<{ status: PersonRedirect; uuid: string }>(
         `api/person/redirect-decision/${taxNumber}`,
         { params }
      );
   }
}
